import { Injectable } from "@angular/core";
import { jwtDecode } from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class JwtService {

    decodeToken(token: string): any {
        return jwtDecode(token);
    }

    getExpiration(token: string): number {
        const decoded: any = jwtDecode(token);
        return decoded.exp;
    }

    isExpired(token: string): boolean {

        const exp = this.getExpiration(token);
        const now = Date.now() / 1000;

        return exp <= now;
    }

    willExpireSoon(token: string, minutes: number = 15): boolean {

        const exp = this.getExpiration(token);
        const now = Date.now() / 1000;

        const seconds = minutes * 60;

        return exp - now < seconds;
    }
}